import { defineStore } from 'pinia';

export const useReceiptStoreEtax = defineStore('receipt', {
  state: () => ({
    receiptNumber: '',
    branchCode: '',
    firstName: '',
    last_name: '',
    surName: '',
    address: '',
    city: '',
    postalCode: '',
    receiptsCode: '', 
    storeNumber: '',   
    email: '', 
    selectedType: '', 
    full_name: '', 
    tax_id: '', 
    branch_code:'',
    store_number:'',
    country:'',
    post_code: '', 
    customer_address: '', 
    customer_address_2: '', 
    phone_number: '', 
    token:'',

  }),
  actions: {
    clear() {
      this.receiptNumber = '';
      this.branchCode = '';
      this.firstName = '';
      this.lastName = '';
       this.surName = '';
      this.address = '';
      this.city = '';
      this.country = '';
      this.postalCode = '';
      this.token = '';
    }
  }
});
